export class SoundConfig {
    static readonly START_GAME_AMBIANCE_CROSS_FADE_DURATION:number = 0;

    static readonly FS_GAME_AMBIANCE:string[] = ["fs1-2","fs1-2","fs3"];
    static readonly GAME_MAIN_AMBIANCE:string = "main1";
    static readonly GAME_MAIN_AMBIANCE2:string = "main2";
    static readonly RESPIN_MUSIC:string = "respinMusic";

    static readonly FS_TOTAL_WIN:string = "winLarge";
    static readonly FS_INTRO:string = "fsIntro";
    static readonly FS_OUTRO:string = "fsOutro";
    static readonly FS_OUTRO_EFFECT:string = "fsEnds";
    static readonly FS_OUTRO_BUTTON:string = "continueButtonFsToMain";

    static readonly REELS_QUICK_SPIN_START:string = "spinStartGuitar1";
    static readonly REELS_SPIN_START:string[] = ["spinStart"];
    static readonly REELS_SPINNING:string = "reelsSpinning";
    static readonly REELS_DEFAULT_STOP:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5", "reelLanding6"];

    static readonly ANTICIPATION_START:string = "anticipation";
    static readonly ANTICIPATION_BIG:string = "anticipationBig";
    static readonly ANTICIPATION_END:string = "anticipationEnds";
    static readonly ANTICIPATION_PLING:string = "anticipationBigEnds";
    static readonly SCATTER_LAND:string[] = ["scatter", "scatter3", "scatter4"];
    static readonly SCATTER_COUNT_1_2:string = "scatter1-2";
    static readonly SCATTER_COUNT_3_4:string = "scatter3-4";
    static readonly SCATTER_COUNT_5:string = "scatter5";
    static readonly SCATTER_WIN:string = "scatterWin";

    static readonly BETLINE_SHAKE:string =  "betlineShake";
    static readonly BETLINE_WIN:string = "betline";
    static readonly BETLINE_WIN_ALL:string = "betlineWin";
    static readonly NORMAL_TOTAL_WINS:string[] = ["winTiny","winSmall","winMedium","winLarge"];
    static readonly NORMAL_COUNTUP:string = "countup";
    static readonly NORMAL_COUNTUP_END:string = "countupEnds";

    static readonly COUNTER_6X6:string = "6x6Countup";

    static readonly BIG_WIN_MUSIC:string = "bigwinMusic";
    static readonly BIG_WIN_MUSIC_END:string = "bigwinEnds";
    static readonly BIG_WIN_INITIAL:string = "bigwinInitialWin";

    static readonly XWAYS_EXPAND_WIN:string = "xwaysExpandWin";
    static readonly XWAYS_EXPAND_WIN_SUPER:string = "xwaysSuperExpandWin";
    static readonly XWAYS_EXPAND_NO_WIN:string = "xwaysExpandNoWin";
    static readonly XWAYS_EXPAND_DEAD:string = "xwaysExpandDead";

    static readonly XWAYS_LAND:string = "xwaysLandning";
    static readonly XWAYS_LAND_DEAD:string = "xwaysLandningDead";

    static readonly XWAYS_WIN:string = "xwaysWin";

    static readonly XWAYS_WIN_DELAY:number = 0.3; // 0.2s


    static readonly WILD_LAND:string = "wildLanding";
    static readonly WILD_MOVES:string = "fsWildsMove";
    static readonly WILD_LOCKS:string = "fsWildLock";

    static readonly WILD_EXPANDS_1:string = "wildExpand1";
    static readonly WILD_EXPANDS_2:string = "wildExpand2";
    static readonly WILD_EXPANDS_QUICK:string = "wildExpandQuick";

    static readonly TRAIN_MOVES:string = "train";
    static readonly TRAIN_BRAKE:string = "trainBrake";
    static readonly TRAIN_OPEN_CLOSE:string = "trainOpenClose";

    static readonly RESPIN_INTRO:string = "respinIntro";
    static readonly RESPIN_END:string = "respinEnds";

    static readonly FENCE_EXPLODE:string = "fenceExplode";

    static readonly CHAIN1:string = "chain1";
    static readonly CHAIN2:string = "chain2";

    static readonly BLACK_SWIPE:string = "blackSwipe";
    static readonly BETLINE_HIGHTLIGHT:string = "betlineHighlight1";
    static readonly BETLINE_HIGHTLIGHT_TINY:string = "betlineHighlightTiny1";

    static readonly NO_WIN_POSTER_SHIT:string = "noWinShit";
    static readonly NO_WIN_POSTER_NO_WIN:string = "noWinNoWin";
    static readonly NO_WIN_POSTER_BULLOCKS:string = "noWinBullocks";

    static readonly FS_MULTIPLIER_ADDED:string = "fsWildMulti";
    static readonly FS_EXTRASPINS_ADDED:string = "fsPlusOne";
    static readonly FS_LIGHTNING:string = "fsLightning";
    static readonly FS_LIGHTNING_BJW:string = "fsLightningFire";
    static readonly FS_UPGRADE:string = "fsUpgrade";

    static readonly SIREN:string = "siren";
    static readonly WIN_CAP_START:string = "capwinStarts";
    static readonly WIN_CAP_MUSIC:string = "capwinMusic";
    static readonly WIN_CAP_ENDS:string = "capwinEnds";

    static readonly EXPANDING_PLING:string = "pling1";

    public static readonly FS_START_SCATTER: string = "fsStartScatter";
    public static readonly FS_START_SCATTER_5_EXPLODE: string = "fsStartScatter5Explode";
    public static readonly FS_START_TRAIN_EXPLODE: string = "fsStartTrainExplode";

    public static readonly NOT_IN_SERVICE_EXPLODE: string = "notInServiceExplode";

    static readonly AS_WIN:string = "winSmall";
    static readonly AS_WIN_BIG:string = "winLarge";
}